import List from "@/components/list";
import vue from "@/main";
import router from "@/router";
import store from "@/store";
import { tableBaseProps } from '@/utils/common.js';

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const flatPermissions = store.getters.flatPermissions;
  // 当增加按钮权限时，需在这维护按钮的权限列表
  const permissionList = [
    "videoIncludeInfo:insert",
    "videoIncludeInfo:delete",
  ];


  // 到班级详情
  function goVideoList(item) {
    let query = { videoId: item.trueVideoId };
    router.push({
      path: "/video",
      query: query,
    });
  }

  // 编辑班级
  function editItem(item) {
    let query = { id: item.videoId };
    router.push({ path: "/contentChecking/add", query: query });
  }

  // 删除班级
  function deleteVideoIncludeInfo(item) {
    vue.$emit("deleteVideoIncludeInfo", item);
  }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    let dealConf = [];
    if (item.videoSource == 2) {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "videoIncludeInfo:insert"]);
      dealConf.push([
        "icon-delete-disable",
        "删除",
        () => {
          return;
        },
        "videoIncludeInfo:delete"
      ])
    } else {
      dealConf.push([ "icon-edit", "编辑", () => { editItem(item); }, "videoIncludeInfo:insert"]);
      dealConf.push([ "icon-delete", "删除", () => { deleteVideoIncludeInfo(item); }, "videoIncludeInfo:delete"])
    }

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const ClassName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="base-hover-char text-three-line" onClick={() => goVideoList(item)}>
        {item.videoName}
      </div>
    );
  };
  const LecturerPost = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="text-two-line" onClick={() => goVideoList(item)}>
        {item.lecturerPost}
      </div>
    );
  };

  const IncludeUnitPosition = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="text-two-line" onClick={() => goVideoList(item)}>
        {item.includeUnitPosition}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      ...tableBaseProps("课件名称", "videoName", "200", false),
      render: (vo) => <ClassName vo={vo} />,
    },
    tableBaseProps("主讲人", "lecturerName", "100"),
    {
      ...tableBaseProps("主讲人单位及职务", "lecturerPost", "120", false),
      render: (vo) => <LecturerPost vo={vo} />,
    },
    tableBaseProps("视频中出现的人物姓名", "includeUserName", "100"),
    {
      ...tableBaseProps("视频人物单位及职务", "includeUnitPosition", "120", false),
      render: (vo) => <IncludeUnitPosition vo={vo} />,
    },
    tableBaseProps("籍贯", "includeNativePlace", "80"),
    tableBaseProps("出现类型", "includeTypeName", "70"),
    tableBaseProps("出现时间", "includeTime", "100"),
    tableBaseProps("课件上线时间", "onlineDate", "150"),
  ];
  let iconNum = 0;
  permissionList.forEach((x) => {
    if (flatPermissions.includes(x)) {
      iconNum += 1;
    }
  });
  if (iconNum > 0) {
    AccountTableConfig.push({
      label: "操作",
      // fixed: "right",
      width: String(iconNum * 30 + 10 > 130 ? 130 : iconNum * 30 + 10),
      render: (vo) => <Deal vo={vo} />,
    });
  }
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
